import {
  ACTIVATE_DMX_DEVICE_PRESET,
  ACTIVATE_DMX_DEVICE_PRESET_SUCCESSFUL,
  ACTIVATE_DMX_DEVICE_PRESET_FAILED,
} from './actionTypes';

export const activateDmxDevicePreset = (preset) => {
  return {
    type: ACTIVATE_DMX_DEVICE_PRESET,
    payload: { preset },
  };
};

export const activateDmxDevicePresetSuccessful = (message) => {
  return {
    type: ACTIVATE_DMX_DEVICE_PRESET_SUCCESSFUL,
    payload: message,
  };
};

export const activateDmxDevicePresetFailed = (message) => {
  return {
    type: ACTIVATE_DMX_DEVICE_PRESET_FAILED,
    payload: message,
  };
};
